import { render } from "./restablecerContrasena.vue?vue&type=template&id=57de5ade&scoped=true"
import script from "./restablecerContrasena.vue?vue&type=script&lang=js"
export * from "./restablecerContrasena.vue?vue&type=script&lang=js"

import "./restablecerContrasena.vue?vue&type=style&index=0&id=57de5ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57de5ade"]])

export default __exports__